module.exports = __webpack_public_path__ + "static/media/underline.9ce3988d.svg";